import * as React from 'react';

/** Matches Tailwind's `md` breakpoint (768px). */
const DESKTOP_QUERY = '(min-width: 768px)';

/**
 * Returns `true` while `query` matches the viewport.
 *
 * Defaults to `false` on the server, on the first render, and where the
 * browser cannot evaluate media queries, so hydration matches SSR output.
 */
export function useMatchesMedia(query: string): boolean {
  const [matches, setMatches] = React.useState(false);

  React.useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return;
    }

    const mql = window.matchMedia(query);
    setMatches(mql.matches);

    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** Returns `true` when the viewport is at or above the `md` breakpoint. */
export function useIsDesktop(): boolean {
  return useMatchesMedia(DESKTOP_QUERY);
}
